import Phaser from 'phaser';
import MainScene from './MainScene';
import PagePlayer from '../PagePlayer';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
    BootScene.that = this;
    PagePlayer.that.showAndResizeMetaInfo();
    //PagePlayer.that.checkCoverWidth();
    //console.log("SUCA");
  }

  preload() {
    for (let x = 0; x < BootScene.spritesheets.length; x++) {
      this.load.spritesheet(
        BootScene.spritesheets[x].id,
        BootScene.spritesheets[x].url,
        BootScene.spritesheets[x].config
      );
    }
  }

  create() {
    this.anims.create({
      key: 'preload',
      frames: this.anims.generateFrameNumbers('loading', {
        frames: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
          37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47
        ]
      }),
      frameRate: 60,
      repeat: -1
    });

    this.createMain();
  }

  createMain() {
    // Add the scene (the scene is not in the config)
    this.scene.add('MainScene', MainScene, false);

    // Start the scene
    this.scene.start('MainScene');

    // Rimuove se stessa
    this.scene.remove();
  }
}

BootScene.spritesheets = [
  {
    id: 'loading',
    url: `${TheApp.Env.BaseUrl}dist-player/assets/ui/loading.png`,
    config: {
      frameWidth: 320,
      frameHeight: 320
    }
  }
];
